"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var prodSubscriptionPlans = [{
  name: 'Basic Package - Annual',
  price: '$200',
  id: 'plan_ES4uWIMB9qbTyv'
}, {
  name: 'Basic Package - Monthly',
  price: '$20',
  id: 'plan_ES4sRMulyYyxEH'
}, {
  name: 'Standard Package - Annual',
  price: '$350',
  id: 'price_1IBhqvCh4NtuacNGChDAI1tz'
}, {
  name: 'Standard Package - Monthly',
  price: '$35',
  id: 'price_1IBhpTCh4NtuacNGZnwAwbgW'
}, {
  name: 'Professional Package - Annual',
  price: '$500',
  id: 'plan_FIATZjlabkAsLp'
}, {
  name: 'Professional Package - Monthly',
  price: '$50',
  id: 'plan_FIARSW6TcxCilv'
}, {
  name: 'Advanced Package - Annual',
  price: 'Custom',
  id: 'I aint got one'
}, {
  name: 'Advanced Package - Monthly',
  price: 'Custom',
  id: 'I aint got one'
}];
var testSubscriptionPlans = [{
  name: 'Basic Package - Annual',
  price: '$200',
  id: 'price_1IGECtCh4NtuacNG0ObYn8KP'
}, {
  name: 'Basic Package - Monthly',
  price: '$20',
  id: 'price_1IGECtCh4NtuacNG0ObYn8KP'
}, {
  name: 'Standard Package - Annual',
  price: '$350',
  id: 'price_1IGED5Ch4NtuacNGPTtDpgZe'
}, {
  name: 'Standard Package - Monthly',
  price: '$35',
  id: 'price_1IGED5Ch4NtuacNGPTtDpgZe'
}, {
  name: 'Professional Package - Annual',
  price: '$500',
  id: 'price_1IGEDKCh4NtuacNGlZ5A1ouG'
}, {
  name: 'Professional Package - Monthly',
  price: '$50',
  id: 'price_1IGEDKCh4NtuacNGlZ5A1ouG'
}, {
  name: 'Advanced Package - Annual',
  price: 'Custom',
  id: 'I aint got one'
}, {
  name: 'Advanced Package - Monthly',
  price: 'Custom',
  id: 'I aint got one'
}];
var planMode = process.env.STRIPE_PLAN_MODE || process.env.STORYBOOK_STRIPE_PLAN_MODE;
var subscriptionPlans = planMode === 'test' ? testSubscriptionPlans : prodSubscriptionPlans;
var _default = subscriptionPlans;
exports["default"] = _default;